import React, { Fragment, useState } from 'react';
import { addList as addToCartService } from '../../Services/Cart.service';
import withReactiveStyleBuyButton from './../withReactiveStyleBuyButton';
import { receive, loadError } from '../../Actions/Cart.action';
import { catchError } from '../../Actions/Error.action';
import { useDispatch } from 'react-redux';
import { translate } from "../../Services/translation";
import ProductBuyButton from "./../Products/ProductBuyButton";
import { clearErrorMessage, setErrorMessage, setMessage } from "../../Actions/ProductDetail.action";

const RegularBuyButton = (props) => {
    const dispatch = useDispatch();

    const onClick = async (items) => {
        dispatch(clearErrorMessage());

        if(props.exceedsStock){
            dispatch(setMessage({
                message: translate('product-variant.notification.error.exceedsstock'),
                type: 'error'
            }));

            return;
        }

        try {
            if (items.length > 0) {
                await addToCartService(items).then((cart) => {
                    dispatch(setMessage({
                        message: translate('product-variant.notification.success.text', props.productName),
                        type: 'info'
                    }));

                    dispatch(receive(cart));
                });
            }
        } catch (ex) {
            dispatch(catchError(ex, (error) => loadError(error)));
        }
    };

    const Button = withReactiveStyleBuyButton(ProductBuyButton, onClick, 'buy-button');

    return <Button {...props}/>;
};

export default RegularBuyButton;
